import axios from '@/libs/axios';
import { ErrorMessage } from '@/libs/Error';

export default class SlsTipoComunicadoClient {
  constructor() {
    this.api = axios;
    this.error = new ErrorMessage();
  }

  async getItems(queries = {}) {
    try {
      const { data } = await this.api.get('/tipo-comunicado');
      return data;
    } catch (error) {
      throw this.error.message(error, 'Erro ao listar as Tipo Comunicado');
    }
  }

  async index(queries = {}) {
    try {
      return await this.api.get('/tipo-comunicado', { params: queries });
    } catch (error) {
      throw this.error.message(error, 'Erro ao listar as Tipo Comunicado');
    }
  }

  async store(data) {
    try {
      const { data: response } = await this.api.post('/tipo-comunicado', data);
      return response;
    } catch (error) {
      throw this.error.message(error, 'Erro ao criar as Tipo Comunicado');
    }
  }

  async show(id) {
    try {
      const { data } = await this.api.get(`/tipo-comunicado/${id}`);
      return data;
    } catch (error) {
      throw this.error.message(error, 'Erro ao buscar a Tipo Comunicado');
    }
  }

  async update(data) {
    try {
      const { data: response } = await this.api.put('/tipo-comunicado', data);
      return response;
    } catch (error) {
      throw this.error.message(error, 'Erro ao atualizar a Tipo Comunicado');
    }
  }

  async destroy(id) {
    try {
      const { data: response } = await this.api.delete(`/tipo-comunicado/${id}`);
      return response;
    } catch (error) {
      throw this.error.message(error, 'Erro ao deletar a Tipo Comunicado');
    }
  }
}
